import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/test.environment';
import {
  RequestEmailPayload,
  RequestEmailResponse
} from '../models/request-email.models';

@Injectable({ providedIn: 'root' })
export class RequestEmailService {
  private readonly endpoint = `${environment.apiBaseUrl}/api/request-emails/send`;

  constructor(private readonly http: HttpClient) {}

  send(payload: RequestEmailPayload): Observable<RequestEmailResponse> {
    const formData = new FormData();
    formData.append('projectNumber', payload.projectNumber.toString());
    formData.append('requestType', payload.requestType.trim().toUpperCase());
    formData.append('requestNumber', payload.requestNumber);
    formData.append('body', payload.body.trim());

    const subjectSuffix = payload.subjectSuffix.trim();
    if (subjectSuffix) {
      formData.append('subjectSuffix', subjectSuffix);
    }

    payload.cc.forEach(address => formData.append('cc', address.trim()));
    payload.files.forEach(file => formData.append('files', file, file.name));

    return this.http.post<RequestEmailResponse>(this.endpoint, formData);
  }
}
